export namespace MyBookingTabShow {
  export type MyBookingTabShowEnum = 'itinerary' | 'traveler' | 'service';
  export const MyBookingTabShowEnum = {
    Itinerary: 'itinerary' as MyBookingTabShowEnum,
    Traveler: 'traveler' as MyBookingTabShowEnum,
    Service: 'service' as MyBookingTabShowEnum,
  };
}
